import { render } from "./ProfilePanel.vue?vue&type=template&id=9c072112"
import script from "./ProfilePanel.vue?vue&type=script&lang=js"
export * from "./ProfilePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__